import {useMemo} from "react"
import {createUseQuery} from "@irati/utils/services/apollo"
import gql from "graphql-tag"

const useFlexiMigrationBase = createUseQuery<any, null>(
  gql`
    query FlexiPointMigration {
      pre: promotionStatus(type: FlexiPointsConversionStatusPre) {
        enabled
      }

      mid: promotionStatus(type: FlexiPointsConversionStatusMid) {
        enabled
      }

      post: promotionStatus(type: FlexiPointsConversionStatusPost) {
        enabled
      }
    }
  `,
  {fetchPolicy: "cache-and-network"}
)

export const FlexiPointMigrationStatuses = {
  PRE: "PRE",
  MID: "MID",
  POST: "POST"
} as const

export type FlexiPointMigrationStatus = keyof typeof FlexiPointMigrationStatuses

export const useFlexiMigration = () => {
  const {data, load} = useFlexiMigrationBase(null)

  const status = useMemo(() => {
    if (data?.pre?.enabled) return FlexiPointMigrationStatuses.PRE
    if (data?.mid?.enabled) return FlexiPointMigrationStatuses.MID
    if (data?.post?.enabled) return FlexiPointMigrationStatuses.POST
    return undefined
  }, [data])

  return {
    load,
    status
  }
}

const ConversionRate = 3.37078652

/**
 * conversion
 * @link https://git.perkbox.io/perkbox-services/wallet/topup-app/-/merge_requests/159/diffs#0ca5a43334669a3619a1bf7a29ada165cb8557c4_0_36
 */
export function flexiConversionAmount(amount: number, state: FlexiPointMigrationStatus) {
  if (amount === 0) return {current: 0, changed: 0}

  switch (state) {
    case "POST":
      return {current: amount, changed: Math.max(1, Math.ceil(ConversionRate * (amount / 100))) * 100}
    case "MID":
      return {current: amount, changed: amount}
    case "PRE":
    default:
      return {current: amount, changed: Math.max(1, Math.ceil(amount / 100 / ConversionRate)) * 100}
  }
}
